import { render } from "./BulkMailDesign.vue?vue&type=template&id=1c79d48a"
import script from "./BulkMailDesign.vue?vue&type=script&lang=js"
export * from "./BulkMailDesign.vue?vue&type=script&lang=js"

import "./BulkMailDesign.vue?vue&type=style&index=0&id=1c79d48a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__